import { render, staticRenderFns } from "./notificationMenu.vue?vue&type=template&id=9055a802&"
import script from "./notificationMenu.vue?vue&type=script&lang=js&"
export * from "./notificationMenu.vue?vue&type=script&lang=js&"
import style0 from "./notificationMenu.vue?vue&type=style&index=0&id=9055a802&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports